import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import { faqs } from "@/mocks/faqs";
import { site } from "@/mocks/site";
import HeroSection from "@/pages/home/components/HeroSection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import HotBoardSection from "@/pages/home/components/HotBoardSection";
import LatestSection from "@/pages/home/components/LatestSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import AnnualSection from "@/pages/home/components/AnnualSection";
import FaqSection from "@/pages/home/components/FaqSection";
import BrandSection from "@/pages/home/components/BrandSection";
import CtaSection from "@/pages/home/components/CtaSection";

const heroImage =
  "https://readdy.ai/api/search-image?query=abstract%20dramatic%20night%20newsroom%20backdrop%20with%20crimson%20and%20amber%20spotlights%20cutting%20through%20haze%2C%20blurred%20pin%20boards%20and%20glowing%20screens%2C%20no%20people%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%20and%20film%20grain&width=1800&height=1000&seq=hero-home&orientation=landscape";

export default function Home() {
  return (
    <SiteLayout>
      <Seo
        title="网红大瓜 | 重磅爆料、惊天大瓜全记录，热门猛料持续更新"
        description="网红大瓜聚合网红圈最新重磅爆料与惊天大瓜，把事件原帖、关键截图和后续进展归到一起看。热门猛料、年度大瓜与超级大瓜持续更新，不用再在热搜里来回翻。"
        keywords={[
          "网红大瓜",
          "网红大瓜重磅爆料",
          "网红大瓜惊天大瓜",
          "网红大瓜猛料曝光",
          "网红大瓜超级大瓜",
          "网红大瓜年度大瓜",
        ]}
        canonicalPath="/"
        image={heroImage}
        imageAlt="网红大瓜首页首屏氛围图"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: site.name,
            url: "https://chengshunjt.cn/",
            description: site.description,
            inLanguage: "zh-CN",
            potentialAction: {
              "@type": "SearchAction",
              target:
                "https://chengshunjt.cn/category/mengliao?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: site.name,
            url: "https://chengshunjt.cn/",
            email: site.email,
            description: site.description,
            foundingDate: site.since,
          },
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "网红大瓜",
            url: "https://chengshunjt.cn/",
            description: site.description,
            inLanguage: "zh-CN",
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: item.answer,
              },
            })),
          },
        ]}
      />
      <HeroSection />
      <FeaturedSection />
      <HotBoardSection />
      <LatestSection />
      <TimelineSection />
      <AnnualSection />
      <FaqSection />
      <BrandSection />
      <CtaSection />
    </SiteLayout>
  );
}